module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e121714"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Inc_9781418557720_epub_c8_r1#Anch00114",
      "id": "Anch0008"
    }
  }, [_vm._v("Encouragement of Friendship "), _c('br'), _c('b', [_vm._v("Words That Matter")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e122514"
    }
  }, [_c('i', [_vm._v("Jonathan, Saul’s son, arose and went to David in the woods and ")]), _c('i', [_vm._v("strengthened his hand in God.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e123314"
    }
  }, [_c('i', [_vm._v("—1 S")]), _c('i', [_vm._v("AMUEL ")]), _c('i', [_vm._v("23:16 ")]), _c('i', [_vm._v("NKJV ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e124714"
    }
  }, [_vm._v("Take a moment to think about someone who is a close friend. Can you recall a time when that person was merely an acquaintance? What was it that took your relationship from acquaintance to friend? A shared interest? Passion for a common cause? Perhaps a heated debate? However your friendship began, things are probably quite different in your relationship today. The polite “hello” of acquaintance days has grown into a vocabulary of deeper relationship, which includes spoken as well as unspoken sentiments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e128114"
    }
  }, [_vm._v("Jonathan was just such a friend to David. David was hiding in the wilderness, attempting to discern God’s will while simultaneously avoiding detection by Saul, who sought his life. Jonathan, Saul’s son, came to David with words of encouragement, saying, “Do not fear, for the hand of Saul my father shall not find you. You shall be king over Israel, and I shall be next to you” (1 Samuel 23:17 NKJV). These words from a mere acquaintance might have been received with a smile and a thank-you, or maybe one of those you-don’t-know-what-you’re-talking-about looks. Yet those were words of encouragement from a true friend, and so the words mattered. Jonathan’s words could be trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e133315"
    }
  }, [_vm._v("The trusted words of a friend can make a positive impact in your life. Listening requires humility, patience, and an open mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e134415"
    }
  }, [_vm._v("Start with humility—know that you aren’t always right. It’s okay to admit you’re not perfect when you’re with a trusted friend. Remember, your friend is on your side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e135615"
    }
  }, [_vm._v("Next, be patient. Let the wise counsel seep into you and steep there for a while. Don’t jump to a wrong conclusion or criticize your friend’s words before you’ve really examined them. It may be tough to hear some of your friend’s words, but you’ll never get the chance if you’re calculating your response while your friend is still speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e137715"
    }
  }, [_vm._v("Finally, be prepared to have your best-laid plans turned upside down, or at least sideways. Sometimes a friend will propose a solution you hadn’t even considered—one that doesn’t make sense at first. An open mind allows you to approach new ideas willingly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e139515"
    }
  }, [_vm._v("Take the encouragement of a friend to heart. Let the words strengthen you. Even if you fail or fall, those words will provide a softer landing place. That’s because the encouraging words of a true friend are inseparable from the unspoken message of friendship—a message of love.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be15442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c11_r1.vue
// module id = 81
// module chunks = 0